type BannerProps = {
  text: string;
  icon?: string;
  textColor?: string;
  className?: string;
};

export const Banner = (props: BannerProps) => {
  const { text, icon, textColor = "text-osBlack", className = "" } = props;

  return (
    <div
      className={`flex items-center justify-center rounded-[18px] w-fit px-5 py-2 border-2 border-osBlack bg-transparent ${className}`}
    >
      {icon && <span className="mr-2">{icon}</span>}
      <span className={`font-semibold ${textColor}`}>{text}</span>
    </div>
  );
};
